import styled from "styled-components";
import color from "../../assets/css/colors";
import { AddProductHeaderPageInterface } from "./interface";

export const AddProductHeader = styled.ul`
    display: flex;
    align-items: center;
    margin-bottom: 34px;
    height: 50px;
    list-style: none;
    padding: 0;

    & li:first-child:after {
        width: 0;
    }
`;

export const AddProductHeaderPage = styled.li`
    font: normal normal 600 16px Muli;
    color: ${(p: AddProductHeaderPageInterface) => p.isActualOrPrevius ? color.primary : color.grayDark } ;
    margin-bottom: 0px;
    line-height: 1;
    cursor: pointer;
    width: 25%;
    position: relative;
    text-align: center;

    &::before {
        display: flex;
        align-items: center;
        justify-content: center;
        content: attr(data-step);
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background: ${(p: AddProductHeaderPageInterface) => p.isActualOrPrevius ? color.primary : color.grayLight } ;
        color: ${(p: AddProductHeaderPageInterface) => p.isActualOrPrevius ? color.white : color.grayDark } ;
        position: absolute;
        top: -50px;
        left: calc(50% - 20px);
        z-index: 99;
    }

    &::after {
        content: '';
        width: 100%;
        height: 5px;
        background: ${(p: AddProductHeaderPageInterface) => p.isActualOrPrevius ? color.primary : color.grayLight } ;
        position: absolute;
        top: -35px;
        left: -50%;
    }

    @media (max-width: 576px) {
        margin-bottom: 5px;
        font-size: 12px;
    }
`;